import { isNil } from 'lodash';
import { ENTITY as Entity } from '../../../modules/accounts/config';
import { AllEntityId } from '../../../modules/campaigns/config/allEntityId';

export const getNextPage = (collection, pageSize, entity) => {
    const filteredCollection =
        entity === Entity.ACCOUNT
            ? collection.filter(account => !isNil(account?.accountId))
            : collection.filter(account => account?.id !== AllEntityId);
    const length = filteredCollection.length;
    const currentPage = Math.ceil(isNaN(length) ? 0 : length / pageSize);
    const nextPage = currentPage + 1;

    return nextPage;
};
